import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

//Components
import Form from './Form.constants';

// Actions de Redux
import { createWarehouse } from '../../redux/warehouses/thunks';
import useScan from '../../hooks/useScan';

const NewWarehouses = () => {
  const navigate = useNavigate();
  // utilizar use dispatch y te crea una función
  const dispatch = useDispatch<any>();
  const { setDestination } = useScan();

  useEffect(() => {
    setDestination('act-a-war', false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialValues = {
    name: '',
    address: '',
    time_zone_id: '',
  };

  // cuando el usuario haga submit
  const submitNewWarehouse = (values: any) => {
    // crear el nuevo warehouse
    dispatch(createWarehouse(values))
      .unwrap()
      .then((res: any) => {
        if (res) {
          navigate('/warehouses', { replace: true });
        }
      });
  };

  return (
    <Form
      submitWarehouse={submitNewWarehouse}
      initialValues={initialValues}
      actionText={'GUARDAR'}
    />
  );
};

export default NewWarehouses;
